import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { PinkNotification } from "../..";
import focusButton from "../../../../assets/icons/focusButton.svg";
import { BoardContext, TableContext, TeamContext } from "../../../../context";
import { Phase } from "../../../../util/enums";

const FocusButton: FC<{}> = () => {
    const { t } = useTranslation();
    const { instructionTutorial } = useContext(BoardContext);
    const { game } = useContext(TeamContext);
    const { setToggleMySolutionFullScreen } = useContext(TableContext);
    const isQuestionPhaseActive = game?.phase === Phase.QUESTION_CARD;
    const zIndexForFocusMode : number = instructionTutorial === "rightSideOfTheScreen" ? 50 : 2;

	return (
		<div className="focus_button_wrapper" style={{zIndex: zIndexForFocusMode}}  onClick={() => setToggleMySolutionFullScreen(true)}>
            {instructionTutorial === "rightSideOfTheScreen" && 
            <div style={{position: "relative", zIndex: -1}}>
                <PinkNotification notificationWidthVW={34} notificationRenderingSide="top" text={t("tipUseFocusModeToHaveAFullViewText")} moveFromTop={-10} progressNumber={10} />
            </div>
            }
            <img className="focus_button" src={focusButton} alt="focus button" />
		</div>
	);
};

export default FocusButton;

